import wwdssCover from "@/assets/img/wwdss-cover.webp";
import rlalCover from "@/assets/img/rlal-cover.webp";
import gracePhoto from "@/assets/img/grace.jpg";

export const ASSETS = {
  wwdssCover,
  rlalCover,
  gracePhoto,
};

// Atmospheric, monochrome-treated backgrounds (rendered with grayscale filter)
export const ATMOSPHERE = {
  highway:
    "https://images.unsplash.com/photo-1625109556932-54e4b69ef4b4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920&ixlib=rb-4.1.0",
  asphalt:
    "https://images.unsplash.com/photo-1635789146064-ffa7966c32e3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920&ixlib=rb-4.1.0",
  trailerPoster:
    "https://images.unsplash.com/photo-1649027421785-6827863f0891?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920&ixlib=rb-4.1.0",
  nightRider:
    "https://images.unsplash.com/photo-1759248762794-71a284210a55?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920&ixlib=rb-4.1.0",
};

export const AMAZON_WWDSS =
  "https://www.amazon.ca/Women-Who-Dont-Sit-Still/dp/B0GTMQR9HW";
export const AMAZON_RLAL =
  "https://www.amazon.ca/Ride-Like-Lady-Beginners-Motorcycling-ebook/dp/B0D6M2VHP5";

// The finished book trailer will be dropped in here later (file URL or embed src).
export const TRAILER_SRC = null;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -10 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
